import React, { useMemo } from 'react';
import { HorizontalBar } from 'react-chartjs-2';
import { tickColor, gridColor, baseFont, AGENT_COLORS } from './chartConstants';

const TopAgentsChart = ({ agents = [] }) => {
    const chartData = useMemo(() => {
        if (!Array.isArray(agents) || agents.length === 0) return null;
        return {
            labels: agents.map(a => a.agent_name),
            datasets: [{
                label: 'Resolved Tickets',
                data:  agents.map(a => a.resolved_count),
                backgroundColor:      agents.map((_, i) => AGENT_COLORS[i % AGENT_COLORS.length]),
                hoverBackgroundColor: agents.map((_, i) => AGENT_COLORS[i % AGENT_COLORS.length].replace('0.85', '1')),
                borderWidth: 0,
            }],
        };
    }, [agents]);

    const options = {
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
            mode: 'index', intersect: false,
            backgroundColor: '#1F2937',
            titleFontFamily: baseFont, titleFontSize: 12, titleFontStyle: 'bold',
            bodyFontFamily: baseFont,  bodyFontSize: 12,
            xPadding: 10, yPadding: 10,
            callbacks: { label: (item) => ` ${item.xLabel} ticket${item.xLabel !== 1 ? 's' : ''} resolved` },
        },
        scales: {
            xAxes: [{ gridLines: { color: gridColor }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, beginAtZero: true, callback: (v) => Number.isInteger(v) ? v : null } }],
            yAxes: [{ gridLines: { display: false }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11 } }],
        },
    };

    if (!chartData) return <div style={{ color: tickColor, padding: 20 }}>No resolved tickets yet</div>;
    return <div style={{ height: '100%', minHeight: 160 }}><HorizontalBar data={chartData} options={options} /></div>;
};

export default TopAgentsChart;
